import Vue from 'vue'
import JwtToken from './jwt-token'
import store from '../store'
import router from '../router/index'

/**
 * Inclui token de autenticação no header de todas as requisições HTTP.
 */
Vue.http.interceptors.push((request, next) => {
  request.headers.set('Authorization', JwtToken.getAuthorizationHeader())
  next()
})

/**
 * Recupera token de autenticação quando o token atual está expirado.
 */
Vue.http.interceptors.push((request, next) => {
  next(response => {
    if (response.status === 401) {
      if (store.getters['App/isAuthenticated']) {
        return JwtToken.refreshToken().then(() => {
          return Vue.http(request)
        }).catch(() => {
          store.commit('App/unauthenticate')
          router.push({ name: 'auth.login' })
        })
      }
    }
  })
})

/**
 * Gerencia o loading da aplicação. Mostra sempre que uma requisição é iniciada e esconde quando uma requisição finaliza.
 */
Vue.http.interceptors.push((request, next) => {
  if (!request.hideLoader) {
    store.commit('App/startLoading')
    next(response => {
      store.commit('App/endLoading')
    })
  } else {
    next()
  }
})

const routes = [
  // {
  //   method: 'GET',
  //   url: process.env.VUE_APP_API_URL + '/v1/course',
  //   response: [
  //     { title: 'Curso 1', subtitle: 'Informações do curso 1' },
  //     { title: 'Curso 2', subtitle: 'Informações do curso 2' },
  //     { title: 'Curso 3', subtitle: 'Informações do curso 3' }
  //   ],
  //   statusCode: 200
  // },
  {
    method: 'POST',
    url: 'quotes/',
    response: { id: 23, body: 'Terse? I can be terse. Once, in flight school, I was laconic.' },
    statusCode: 200
  },
  {
    method: 'GET',
    url: 'quotes/18/',
    response: { id: 18, body: 'Curse your sudden but inevitable betrayal!' }
  }
]

Vue.http.interceptors.unshift((request, next) => {
  const route = routes.find((item) => {
    return (request.method === item.method && request.url === item.url)
  })
  if (!route) {
    // we're just going to return a 404 here, since we don't want our test suite making a real HTTP request
    next()
  } else {
    next(
      request.respondWith(
        route.response,
        {
          status: route.statusCode
        }
      )
    )
  }
})
